import IMask from 'imask';

export default class Masks {
    constructor() {
        this.creditCardMask = document.querySelectorAll('#cardNumber');
        this.cardExpiryMask = document.querySelectorAll('#cardExpiry');
        this.phoneMask = document.querySelectorAll('.telMask');
        this.cpfMask = document.querySelectorAll('.cpfMask');
        this.cnpjMask = document.querySelectorAll('.cnpjMask');
        this.cepMask = document.querySelectorAll('.cepMask');
        this.moneyMask = document.querySelectorAll('.moneyMask');
        this.dateMask = document.querySelectorAll('.dateMask');

        this.ready();
    }

    ready() {
        var maskCreditCardOptions = {
            mask: '0000 0000 0000 0000',
        };

        var maskCardExpiryOptions = {
            mask: '00/00',
        };

        var maskPhoneOptions = {
            mask: '(00)00000-0000',
        };

        var maskCpfOptions = {
            mask: '000.000.000-00',
        };

        var maskCnpjOptions = {
            mask: '00.000.000/0000-00',
        };

        var maskCepOptions = {
            mask: '00000-000',
        };

        var maskDateOptions = {
            mask: '00/00/0000',
        };

        var maskMoneyOptions = {
            mask: 'num',
            blocks: {
                num: {
                    mask: Number,
                    thousandsSeparator: '',
                    radix: '.',
                    scale: 2,
                    signed: false,
                    normalizeZeros: true,
                    padFractionalZeros: true,
                    min: 0,
                },
            },
        };

        //Mascara Cartão de Cŕedito
        if (this.creditCardMask.length > 0) {
            this.creditCardMask.forEach((el) => {
                IMask(el, maskCreditCardOptions);
            });
        }

        //Mascara Expiração Cartão de Cŕedito
        if (this.cardExpiryMask.length > 0) {
            this.cardExpiryMask.forEach((el) => {
                IMask(el, maskCardExpiryOptions);
            });
        }

        //Mascara Telefone
        if (this.phoneMask.length > 0) {
            this.phoneMask.forEach((el) => {
                IMask(el, maskPhoneOptions);
            });
        }

        //Mascara CPF
        if (this.cpfMask.length > 0) {
            this.cpfMask.forEach((el) => {
                IMask(el, maskCpfOptions);
            });
        }

        //Mascara CNPJ
        if (this.cnpjMask.length > 0) {
            this.cnpjMask.forEach((el) => {
                IMask(el, maskCnpjOptions);
            });
        }

        //Mascara CEP
        if (this.cepMask.length > 0) {
            this.cepMask.forEach((el) => {
                IMask(el, maskCepOptions);
            });
        }

        //Mascara Valores
        if (this.moneyMask.length > 0) {
            this.moneyMask.forEach((el) => {
                IMask(el, maskMoneyOptions);
            });
        }

        //Mascara Datas
        if (this.dateMask.length > 0) {
            this.dateMask.forEach((el) => {
                IMask(el, maskDateOptions);
            });
        }
    }
}

new Masks();
